import React from 'react';
import { Row, Col, Card, CardBody, Button, Modal } from 'reactstrap';

import Loader from '../../shared/loader/loader';
import Dropzone from 'react-dropzone';

const AppendixModal = (props) => {
  const {
    modalOpen,
    toggleModal,
    loader,
    handleAcceptedFiles,
    dropzoneElement,
  } = props;


  return (
    <Modal
      isOpen={modalOpen}
      toggle={() => {
        toggleModal();
      }}
    >
      <Card>
        <CardBody>
          <Loader loading={loader} />
          <Row>
            <Col md="12">
              <h5>Attachment</h5>
            </Col>
            <Col md="12">
              <h6 className="text-secondary">Fill all information below</h6>
            </Col>
            <Col md="12">

              <div style={{ marginLeft: '18%' }}>
                <Dropzone
                  ref={dropzoneElement}
                  multiple={false}
                  onDropRejected={(e) => {
                    //   setImageError('Please select an image file!');
                  }}
                  accept="image/jpeg, image/png, image/svg, .jpeg, .png, .svg"
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles);
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <>

                      <div className="dropzone subject-image-dropzone border rounded p-4 text-center bg-light cursor-pointer mt-2 d-flex align-items-center">
                        <div className="dz-message needsclick" {...getRootProps()}>
                          <input {...getInputProps()} />
                          <div className="dz-message needsclick subject-icon-dz">
                            <div className="mt-4">
                              <i className="display-4 text-muted bx bxs-cloud-upload"></i>
                            </div>
                            <h5 className="font-size-12">Drop files here or click to upload.</h5>
                            <p className="font-size-10">Minimum file size 512x512, File type PNG.</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Dropzone>








              </div>

            </Col>
            <Col md="12" className="mt-4">
              <Row className="justify-content-center">

                <Button
                  type="button"
                  onClick={() => {
                    toggleModal();
                  }}
                  className="agora-button cancel-button border-radius"
                >
                  Close
                </Button>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Modal>
  );
};

export default AppendixModal;
